__turbopack_context__.v({
  "clickable": "Sticker-module-scss-module__6rYWmG__clickable",
  "sticker": "Sticker-module-scss-module__6rYWmG__sticker",
  "trafficSign": "Sticker-module-scss-module__6rYWmG__trafficSign",
});
